import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgImageIconSecondary from './svgs/ImageIconSecondary.js';
import SvgImageIcon from './svgs/ImageIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var imageIcon = (props => useIcon(SvgImageIcon, SvgImageIconSecondary, props));

export { imageIcon as default };
